import Types from "@Types";

const reducer = (state = [], action) => {
    switch (action.type) {
        //? inset Contract_Contract
        case Types.AccountSetting.insert:
            return [...state, action.payload.value];
        //? update AccountSetting
        case Types.AccountSetting.update:
            return [
                ...state.map((x) => {
                    if (x.Series === action.payload.Series) return action.payload.value;
                    else return x;
                }),
            ];
        //? delete AccountSetting
        case Types.AccountSetting.delete:
            return [...state.filter((x) => x.Series !== action.payload.Series)];
        // ? clear all data
        case Types.clear:
            return [];
        //? set AccountSetting
        case Types.AccountSetting.set:
            return action.payload ?? [];
        // ? default
        default:
            return state;
    }
};

export default reducer;
